import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-file-programming-header',
  templateUrl: './file-programming-header.component.html',
  styleUrls: ['./file-programming-header.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FileProgrammingHeaderComponent {
  @Input() activeFilterCount = 0;
  @Input() heroClass = '';
  @Input() icon = 'folder_open';
  @Input() isLoading = false;
  @Input() resultCount = 0;
  @Input() subtitle = '';
  @Input() title = '';
  @Input() eyebrow = '';

  @Output() refresh = new EventEmitter<void>();
}
